import SchedulingServicesView from './SchedulingServicesView';

export default SchedulingServicesView;